<template>
    <div>
        <div
            class="bubble pin h-12 w-12 rounded-full p-1"
            :id="smartmapMarkerId"
            :class="[classObject, fadeClass]"
            @click="$emit('clicked')"
            @mouseover="showTooltip"
            @mouseout="hideTooltip"
        >
            <span
                ><a href="javascript:void(0)" class="bubble_link"
                    ><img :src="location.properties.marker_image_url" loading="lazy" class="inline rounded-full"/></a
            ></span>
            <div class="stamp_group">
                <a
                    class="stamp_link"
                    href="javascript:void(0)"
                    v-for="item, index in location.properties.items"
                    :key="'badge-item-' + item.id"
                    :style="{left: -(index*15) - 6 + 'px'}"
                    ><img :src="item.image_url" alt="" loading="lazy" class="inline rounded-full"
                /></a>
            </div>
        </div>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
    props: {
        currentCategoryId: {
            type: Number,
            default: 0
        },
        location: {
            type: Object,
            required: true
        },
        isShowCluster: {
            type: Boolean,
            default: false
        },
        mySmartMap: {
            type: Object,
            default: function () {
                return null;
            }
        }
    },
    computed: {
        classObject() {
            var catId = 'cat-' + this.currentCategoryId;
            return {
                [catId]: !this.currentCategoryId,
                m_square: this.location.properties.marker_style == 'square'
            };
        },
        fadeClass() {
            return !this.isShowCluster || !this.location.properties.point_in_cluster
                ? 'loc-fade-in'
                : 'loc-fade-out';
        },
        smartmapMarkerId() {
            return 'smartmap-marker-' + this.location.properties.id;
        }
    },
    methods: {
        showTooltip() {
            let rect = document.getElementById(this.smartmapMarkerId).getBoundingClientRect();
            let tooltip = {
                title: this.location.properties.title,
                category_title: this.location.properties.category.title,
                top: rect.top + 80 + 'px',
                left: rect.left + 50 + 'px'
            };
            this.$emit('updatedTooltip', tooltip);
        },
        hideTooltip() {
            let tooltip = {
                title: '',
                category_title: '',
                top: '',
                left: ''
            };
            this.$emit('updatedTooltip', tooltip);
        }
    },
    mounted() {
        new mapboxgl.Marker(this.$el)
            .setLngLat(this.location.geometry.coordinates)
            .addTo(this.mySmartMap);
    }
};
</script>

<style>
.loc-fade-out {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 500ms;
}
.loc-fade-in {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 500ms;
}
</style>